type ImagesType = {
  url: string;
  alt: string;
}[];

export const logoList: ImagesType = [
  {
    url: `${window.template_root}/v1/references/harvard-logo.png`,
    alt: "Harvard University",
  },
  {
    url: `${window.template_root}/v1/references/columbia-logo.png`,
    alt: "Columbia University",
  },
  {
    url: `${window.template_root}/v1/references/natureneuroscience-logo.png`,
    alt: "Nature Neuroscience",
  },
  {
    url: `${window.template_root}/v1/references/jneurosci-logo.png`,
    alt: "JNeurosci, The Journal of Neuroscience",
  },
  {
    url: `${window.template_root}/v1/references/nalanda-logo.png`,
    alt: "Nalanda University",
  },
];
